import { twJoin } from 'tailwind-merge';
import { match } from 'ts-pattern';
import { Button } from '../catalyst-ui-kit/button';
import { AlertAction, AlertVariantStyles } from './Alert.types';

interface Props {
  actions: AlertAction[];
  variantStyles: AlertVariantStyles;
  className?: string;
}

export const AlertActions: React.FC<Props> = ({ actions, variantStyles, className }) => {
  return (
    <div className={className}>
      {actions.map((action) => {
        const props = match(action.type)
          .with('outline', () => ({ outline: true }))
          .with('plain', () => ({ plain: true }))
          .with('text', () => ({ text: true }))
          .with('solid', () => ({ color: variantStyles.button }));

        return (
          <Button
            {...props}
            key={action.label}
            onClick={action.onClick}
            // Catalyst checks `'href' in props`, so we only pass it in if set.
            {...(action.href ? { href: action.href } : {})}
            className={twJoin(
              '-my-1 px-2 py-1 text-xs font-medium sm:px-2 sm:py-1 sm:text-xs',
              action.type !== 'solid' ? variantStyles.foreground : ''
            )}
          >
            {action.label}
          </Button>
        );
      })}
    </div>
  );
};
